export default "__VITE_ASSET__8101e0b7__"